import React, { createContext, useState, useContext, useEffect } from 'react';
import { themes } from '../styles/themes';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const saved = localStorage.getItem('theme');
    if (saved && themes[saved]) {
      return saved;
    }
    // Map old 'default' to new 'light'
    if (saved === 'default') {
      return 'light';
    }
    return 'light'; // Light is now the default
  });

  const theme = themes[currentTheme] || themes.light;

  useEffect(() => {
    localStorage.setItem('theme', currentTheme);
    // Update document background for better visual feel
    document.documentElement.style.background = theme.background;
  }, [currentTheme, theme.background]);

  const switchTheme = (themeName) => {
    if (themes[themeName]) {
      setCurrentTheme(themeName);
    }
  };

  const toggleTheme = () => {
    setCurrentTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ theme, currentTheme, switchTheme, toggleTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};